import WildesAvatar from "../assets/wildes.jpg";
import MateusAvatar from "../assets/mateus.jpeg";
import JeanAvatar from "../assets/jean.jpeg";
import GabrielAvatar from "../assets/gabriel.jpeg";

const mockTeam = [
    {
        id: "t1",
        name: "Wildes",
        role: "CEO / Director",
        bio: "Responsável pela direção criativa da Lusco e pela construção da linguagem visual de cada projeto.",
        avatarUrl: WildesAvatar,
        tags: ["Direção", "Criativo", "Estratégia"],
    },
    {
        id: "t2",
        name: "Welder",
        role: "Cinegrafista",
        bio: "Atua na captação e execução visual dos projetos com foco técnico e sensibilidade estética.",
        avatarUrl: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1000&auto=format&fit=crop",
        tags: ["Captação", "Câmera", "Execução"],
    },
    {
        id: "t3",
        name: "Jean Phelipe",
        role: "Cinegrafista / Editor / FPV Pilot",
        bio: "Une captação dinâmica, edição e visão aérea para ampliar o impacto visual das entregas.",
        avatarUrl: JeanAvatar,
        tags: ["FPV", "Edição", "Captação"],
    },
    {
        id: "t4",
        name: "Ruan",
        role: "Cinegrafista / Editor",
        bio: "Participa da construção visual dos projetos desde a captura até a finalização.",
        avatarUrl: "https://images.unsplash.com/photo-1504593811423-6dd665756598?q=80&w=1000&auto=format&fit=crop",
        tags: ["Edição", "Captação", "Narrativa"],
    },
    {
        id: "t5",
        name: "Gabriel Porto",
        role: "Cinegrafista / Editor",
        bio: "Contribui na leitura estética e na edição com foco em ritmo, linguagem e retenção.",
        avatarUrl: GabrielAvatar,
        tags: ["Câmera", "Edição", "Impacto"],
    },
    {
        id: "t6",
        name: "Leandro",
        role: "Cinegrafista / Editor",
        bio: "Atua na execução técnica e criativa dos materiais com consistência visual.",
        avatarUrl: "https://images.unsplash.com/photo-1507591064344-4c6ce005b128?q=80&w=1000&auto=format&fit=crop",
        tags: ["Captação", "Pós", "Visual"],
    },
    {
        id: "t7",
        name: "Eduardo Dutra",
        role: "Fotógrafo",
        bio: "Especialista em capturar imagem fixa com força estética e valor de percepção.",
        avatarUrl: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=1000&auto=format&fit=crop",
        tags: ["Fotografia", "Editorial", "Luz"],
    },
    {
        id: "t8",
        name: "Matheus",
        role: "Fotógrafo",
        bio: "Atua na construção de imagens com foco em presença visual, composição e impacto.",
        avatarUrl: MateusAvatar,
        tags: ["Foto", "Composição", "Presença"],
    },
    {
        id: "t9",
        name: "William",
        role: "Mobile",
        bio: "Cria conteúdos mobile pensados para circulação estratégica, velocidade e retenção.",
        avatarUrl: "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?q=80&w=1000&auto=format&fit=crop",
        tags: ["Mobile", "Conteúdo", "Social"],
    },
];

export default mockTeam;